import React from 'react';
import { HomeType } from '../../../../domain/FilterTypes';
import { homeTypeOptions } from '../../../../domain/filterOptions';

interface HomeTypeOption {
  label: string;
  value: HomeType;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

interface HomeTypeBodyProps {
  selectedTypes: HomeType[];
  onToggle: (homeType: HomeType) => void;
}

export const HomeTypeBody = ({ selectedTypes, onToggle }: HomeTypeBodyProps) => {
  return (
    <div className="grid grid-cols-4 gap-3">
      {homeTypeOptions.map((option: HomeTypeOption) => {
        const Icon = option.icon;
        const isSelected = selectedTypes.includes(option.value);

        return (
          <button
            key={option.value}
            onClick={() => onToggle(option.value)}
            className={`
              flex flex-col items-center justify-center gap-2 
              p-3 rounded-xl border transition-all 
              hover:shadow-sm hover:bg-gray-50
              ${isSelected
            ? 'border-blue-500 bg-blue-50 text-blue-700 shadow-sm'
            : 'border-gray-200 text-gray-700'
          }
            `}
          >
            <Icon className={`w-7 h-7 ${isSelected ? 'text-blue-600' : 'text-gray-700'}`} />
            <span className="text-sm font-medium text-center leading-tight">
              {option.label}
            </span>
          </button>
        );
      })}
    </div>
  );
};
